import { Affix, Button, Card, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import LienCostForm from "../LienCostForm";

const AddLienCost = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/import-export-expense-tracking/lien-cost");
  };

  const addNewLienCost = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add New Lien Cost"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discardForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addNewLienCost()}
              >
                Add Lien Cost
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <LienCostForm form={form} />
    </>
  );
};

export default AddLienCost;
